import React from 'react';

export const LoadingSpinner = ({ size = 'medium', fullScreen = false }) => {
  const sizeMap = {
    small:  'w-4 h-4 border-2',
    medium: 'w-7 h-7 border-2',
    large:  'w-10 h-10 border-[3px]',
  };

  const spinner = (
    <div
      className={[
        sizeMap[size] || sizeMap.medium,
        'rounded-full border-ink-200 border-t-brand-600 animate-spin',
      ].join(' ')}
    />
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-white/80 backdrop-blur-sm flex items-center justify-center z-50">
        <div className="flex flex-col items-center gap-3">
          {spinner}
          <span className="text-sm text-ink-500 font-medium">Загрузка...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center p-6">
      {spinner}
    </div>
  );
};

export default LoadingSpinner;
